import  { useContext, useEffect, useState, useRef } from "react";
import styles from "./index.module.css";
import { json, useLocation, useNavigate, useParams } from "react-router-dom";
import InputText from "../../../components/atoms/InputText";
import { Box, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Label from "../../../components/atoms/Label";
import ArrowLeft from "../../../images/icons/arrow_left.svg";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import FeemonkText from "../../../components/atoms/FeemonkText";
import { DataContext } from "../../../context/DataContext";
import { DataContextType } from "../../../types/DataContextType";
import { createApplication } from "../../../services/application";
import axios from "axios";
import moment from "moment";
import { ApplicantStage } from "../../../utils/applicationStage";
import { encode } from "punycode";
import axiosInstance from "../../../../helpers/axios";
import CustomTextField from "../../../../Components/Mainpage/Components/TextField/TextField";
import CustomAutoComplete from "../../../../Components/Mainpage/Components/AutoComplete/AutoComplete";
import {Button} from "@mui/material";
interface Institute {
  brandName: string
}

function StudentDetails() {
  const navigate = useNavigate()
  const location = useLocation()
  const stateData = location?.state?.data
  const data = sessionStorage.getItem("data")
    let [userData, setUserData] = useState<{
      application:string,
      dob:string,
      applicationId: string;
      userId: string;
      email: string;
      panId: string;
      dateOfBirth: string;
      instituteId: string;
      firstName: string;
      lastName: string;
      mobile: string;
      course: string;
      fees: number;
      studentName: string;
      instituteName: string;
      redirectUrl: string;
      channelId: number;
      flow:string;
    }>({
      application:'',
      applicationId: "",
      userId: "",
      instituteId: "",
      firstName: "",
      lastName: "",
      panId: "",
      dateOfBirth: "",
      dob:'',
      email: "",
      mobile: "",
      course: "",
      fees: 0,
      studentName: "",
      instituteName: "",
      redirectUrl: "",
      channelId: 0,
      flow:''
    });
    useEffect(() => {
      if (data) {
        try {
          const jsonData = atob(data)
          setUserData(JSON.parse(jsonData));
        } catch (error) {}
      }
  
    }, []);
  // Resolve userId and applicationId with fallbacks (include stateData.id)
  const resolvedUserId = userData?.userId || stateData?.userId || stateData?.id || "";
  const resolvedApplicationId = userData?.applicationId
    ? userData.applicationId
    : stateData?.existing
    ? stateData.applicationId
    : stateData?.application || "";
  const [studentName, setStudentName] = useState(stateData?.selectedCard==='parent'? '':  stateData?.studentName)
  const [instituteName, setInstituteName] = useState<string>(
    String(stateData?.instituteName || userData?.instituteName || "")
  );
  const [courseName, setCourseName] = useState<string>(
    String(stateData?.courseName ?? stateData?.course ?? "")
  );
  const [courseFees, setCourseFees] = useState<number | string>(
    stateData?.courseFees ?? userData?.fees ?? ""
  );
  const [instituteList, setInstituteList] = useState<Institute[]>([])
  const [email, setEmail] = useState('')
  console.log(stateData, 'student details page')

  

  const fetchedRef = useRef(false);

  useEffect(() => {
    // Fetch summary once per page visit (guarded to avoid duplicate requests
    // caused by StrictMode double-mounts or rapid state updates).
    if (!resolvedUserId || !resolvedApplicationId) return;
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const controller = new AbortController();

    const fetchSummary = async () => {
      try {
        const response = await axios(
          `${process.env.REACT_APP_DASHBOARD_URL}/summary/user?id=${resolvedUserId}&applicationId=${resolvedApplicationId}`,
          { signal: controller.signal }
        );

        if (response?.status === 200) {
          const {
            studentName: sName,
            courseFees: cFees,
            instituteName: iName,
            courseName: cName,
            email: mail,
          } = response?.data?.data || {};

          setStudentName(
            String(sName ?? (stateData?.selectedCard === "parent" ? "" : stateData?.studentName ?? ""))
          );
          setCourseName(String(cName ?? stateData?.courseName ?? stateData?.course ?? ""));
          setInstituteName(String(iName ?? stateData?.instituteName ?? ""));
          setCourseFees(cFees ?? stateData?.courseFees ?? userData?.fees ?? "");
          setEmail(String(mail ?? stateData?.email ?? ""));
        }
      } catch (err: any) {
        if (err?.name !== "CanceledError" && err?.name !== "AbortError") {
          console.log(err, "summary fetch error");
        }
      }
    };

    fetchSummary();

    return () => {
      controller.abort();
    };
  }, [resolvedUserId, resolvedApplicationId]);
  const getInstituteInfo= async (searchVal: any)=>{
    setInstituteName(searchVal)
      try {
        if(searchVal?.length>=4){
            const response = await axiosInstance(`${process.env.REACT_APP_DASHBOARD_URL}/institute/info/name?name=${searchVal}`)
            const list = response?.data?.data
            setInstituteList(list)
          }
      } catch (error) {
        setInstituteList([])
        console.log(error, 'institute api err')
      }
 
  }
   

  const handleInstituteSelect = (name: string)=> {
    setInstituteName(name)
    setInstituteList([])
  }
  const validateEmail = (email: any) => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email)
  
  };


  const updateEmail = async () => {
    // compute fallbacks for userId and applicationId
    const userIdForRequest = userData?.userId || stateData?.userId || stateData?.id || "";
    const applicationIdForRequest = userData?.applicationId
      ? userData.applicationId
      : stateData?.existing
      ? stateData.applicationId
      : stateData?.application || "";

    // if channel is 12, use special memberId else use resolved userId
    const memberIdForAuth = userData?.channelId === 12 ? "7b75d903-dabf-4571-9052-61c825403004" : userIdForRequest;

    try {
      const response1 = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/login/auth`, {
        method: "POST",
        body: JSON.stringify({ memberId: memberIdForAuth }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result1 = await response1.json();
      const token = result1.data;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // ensure we have a userId and applicationId before calling summary/update
      if (!userIdForRequest || !applicationIdForRequest) {
        console.warn('Missing userId or applicationId for summary/update', { userIdForRequest, applicationIdForRequest });
        return;
      }

      await axios.post(
        `${process.env.REACT_APP_DASHBOARD_URL}/summary/update`,
        { email, applicationId: applicationIdForRequest, userId: userIdForRequest },
        { headers }
      );
    } catch (err) {
      console.log(err);
    }
  }


  const handleContinue = async () => {
    updateEmail()
    const data = {
     applicationId: resolvedApplicationId,
     userId: resolvedUserId,
      courseFees:  courseFees,
      instituteName: instituteName,
      courseName: courseName,
      isCoapplicant: true,
      loanAmount: courseFees,
      studentName: studentName,
      channel:userData?.channelId?userData?.channelId:"2"
    }
    const response1 = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/login/auth`, {
        method: "POST",
        body: JSON.stringify({
          memberId:userData.channelId==12 ?"7b75d903-dabf-4571-9052-61c825403004":location?.state?.data?.userId,
          // memberId: "26ae9a50-b0cd-4e7a-abc4-705edd5ae399",
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result1 = await response1.json();
      const token = result1.data;
    const authToken = token?token:localStorage.getItem("auth_token") || "";
   
    try {
      const response = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/admin/application/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        console.log(response)
      }
  
      const result = await response.json();
      const passData = {...location?.state?.data, fees: courseFees, courseFees}
      navigate("/bank-statement-upload", {
          state: { data:  passData },
      });
      return true
    } catch (error) {
      console.log(error, 'error')
      return false;
    }

 }


  return (
    <div className={styles.body}>
   
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.container}>
             <div className={styles.title}>
                <h1 className={styles.headerText}>Student Details</h1>
             </div>
           <div className={styles.studentFieldsContainer}>
          {stateData?.selectedCard==='parent' && <CustomTextField label='Student Name' value={studentName} handleTextFieldOnChange={(sName: any) => setStudentName(sName)} />}
          <CustomTextField label='Email' value={email} handleTextFieldOnChange={(email: any) => setEmail(email)} />
          <CustomAutoComplete label={'Institute Name'} id='instituteName' value={instituteName} options={instituteList} handleAutoCompleteChange={(name: any) => getInstituteInfo(name)} /> 

          <CustomTextField label='Class / Course Name' value={courseName} handleTextFieldOnChange={(course: any) => setCourseName(course)} />
          <CustomTextField label='Course Fee' value={courseFees} type='number' handleTextFieldOnChange={(fees: any) => setCourseFees(fees)} />
       <div style={{alignSelf:'center', marginTop:'5px'}}>
            <Button   color='error' variant='contained' sx={{textTransform:'none', fontFamily:'Outfit'}} onClick={handleContinue}
                  disabled={(stateData?.selectedCard !== 'student' && !studentName) || !instituteName || !courseName || !courseFees || !validateEmail(email)}
                
            >Continue</Button>
          </div>
          </div> 
         
        </div>
        <br />
        <Footer />
      </div>
    </div>
  );
}

export default StudentDetails;
